export const description =
  'Sign up as an <strong>influencer or media representative</strong> for exclusive VIP Preview Day access and full admission to all four days of the Super B RV Show. ';
export const checkboxTerms =
  'I accept the terms and conditions outlined in our La Mesa | RecVan <a class="underline" href="/privacy-policy">privacy policy</a>';
export const checkBoxSubscribe = 'Subscribe to event and news updates from La Mesa Rec Van.';
export const messageError = 'An error has occurred, please try again later or contact us using alternative methods';
export const messageSuccess = 'Thank you for Contacting Us!';
